import type { LevelId, LevelNumber } from '@/state/types';

/**
 * Engine slot → displayed level number. Used when a staging level's
 * canonical (designed) number doesn't match the engine slot it occupies.
 * Anything not listed here defaults to its engine number.
 */
const DISPLAY_NUMBER_OVERRIDES: Partial<Record<LevelNumber, number>> = {
  34: 41,
  35: 43,
  36: 44,
};

export function getLevelDisplayNumber(n: LevelNumber): number {
  return DISPLAY_NUMBER_OVERRIDES[n] ?? n;
}

export function getLevelDisplayLabel(id: LevelId): string {
  switch (id.kind) {
    case 'LEVEL':
      return `Level ${String(getLevelDisplayNumber(id.n))}`;
    case 'FALSE_ENDING':
      return 'FALSE ENDING';
    case 'ENDGAME':
      return 'ENDGAME';
    case 'GAME_OVER':
      return 'GAME OVER';
  }
}
